module.exports = __webpack_public_path__ + "static/2022_resume-475075c6c03bd6918d3125f024757999.pdf";